import React from 'react'
import { Skeleton } from '@material-ui/lab'

import * as S from '../resultsSummaryCard.styles'

export const ResultsSummaryCardSkeleton = () => {
    return (
        <S.ResultsSummaryCard>
            <S.SummaryTitle>
                <Skeleton width={150} />
            </S.SummaryTitle>
            <S.SummaryTooltip>
                <Skeleton width={100} height={20} />
            </S.SummaryTooltip>
        </S.ResultsSummaryCard>
    )
}
